import { CSSObject } from '@chakra-ui/react';
import bg from '../../../assets/slambet/images/onboarding/onboardingBg.png';
import slamBorder from '@/assets/slambet/images/backgrounds/slamBorder.svg';

export const WrapperFlexOnboarding: CSSObject = {
  bgImage: `url(${bg}), linear-gradient(180deg, var(--bc-colors-beta-600), var(--bc-colors-beta-700))`,
  bgSize: 'cover',
  bgRepeat: 'no-repeat',
  justifyContent: 'center',
};
export const WrapperOnboarding: CSSObject = {
  display: 'grid',
  gridTemplateColumns: ['1fr', null, '300px'],
  gridTemplateRows: ['auto 1fr', null, '1fr'],
  gap: '0px 0px',
  gridAutoFlow: ['row', null, 'unset'],
  gridTemplateAreas: [
    `
      "."
      "."
    `,
    null,
    `
      ". ."
    `,
  ],
  maxH: ['full', null, 'unset'],
  minH: [null, null, '670px'],
  mx: [null, null, 'auto'],
  my: [null, null, 'auto'],
  borderRadius: [null, null, 'lg'],
  boxShadow: [
    null,
    null,
    '0px 3px 6px 0px rgba(0, 0, 0, 0.35), 0px 0px 0px 4px rgba(18, 23, 30, 1) inset, 0px 0px 0px 5px rgba(255, 255, 255, 0.25) inset',
  ],
  w: ['100dvw', null, 'unset'],
  p: ['unset', null, '5px'],
  pos: 'relative',
  '&:before': {
    content: ['none', null, '""'],
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    filter: 'drop-shadow(0px 1px 0 rgba(0, 0, 0, 0.2))',
    border: '0px solid transparent',
    borderImage: `url(${slamBorder}) 50`,
    pointerEvents: 'none',
    borderImageWidth: '50px',
  },
};
export const WrapperContent: CSSObject = {
  display: 'flex',
  flexDir: 'column',
  py: ['4', null, '10'],
  px: ['2', null, '10'],
  flex: [null, null, 1],
  my: ['0', null, 'auto'],
  maxW: ['auto', null, '460px'],
  h: '100%',
  bg: 'unset',
  '#email': {
    bg: 'blackAlpha.400',
    boxShadow:
      '0px 1px 0px 0px rgba(255, 255, 255, 0.1), 0px 1px 5px 0px rgba(0, 0, 0, 0.15) inset',
    color: 'white',
    fontWeight: 'normal',
    borderRadius: 'lg',
    h: '38px',
    border: 'none',
    ':hover, :focus': {
      bg: 'alpha.600',
    },
  },
  '.chakra-form-control': {
    '.chakra-form__label': {
      color: 'white',
      fontSize: 'xs',
      fontWeight: 'medium',
    },
  },
};
export const Title: CSSObject = {
  color: 'white',
  fontSize: 'md',
  fontFamily: 'accent',
  fontStyle: 'normal',
  fontWeight: 'normal',
  textTransform: 'uppercase',
  display: 'flex',
  mb: '4',
};
export const Input: CSSObject = {
  alignSelf: 'stretch',
  h: '38px',
  '&&&': {
    borderRadius: 'md',
    bg: 'blackAlpha.400',
    boxShadow:
      '0px 1px 0px 0px rgba(255, 255, 255, 0.1), 0px 1px 5px 0px rgba(0, 0, 0, 0.15) inset',
    border: 'none',
    color: 'white',
    fontWeight: 'normal',
    '&&:hover, &&:focus': {
      bg: 'blackAlpha.400',
    },
    _placeholder: {
      color: 'white',
    },

    '+ .chakra-input__right-element': {
      color: '#FF9F1C',
    },
  },
};
